import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { ReactComponent as BooksIcon } from "../../../../../../../images/library_books_24.svg";

const useStyles = makeStyles({
  emptyPlan: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    color: "#CACCD1",
    marginTop: 35,
    "& > h4": {
      marginTop: 20
    }
  }
});

export default function NoData({ title, desc }) {
  const { emptyPlan } = useStyles();
  return (
    <>
      <div className={emptyPlan}>
        <BooksIcon />
        <h4>{title}</h4>
        <p>{desc}</p>
      </div>
    </>
  );
}
